// Contains the hours at which different periods of the day start.
// Morning starts at 6 AM, Afternoon at 12 PM, and Evening at 6 PM.
export enum TimesOfDay {
  Morning = 6,
  Afternoon = 12,
  Evening = 18,
}

export enum PeriodsOfDay {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
}
